
















































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import addNode from "@/components/addNode/index.vue"
import { UserModule } from '@/store/modules/user'

@Component({
  components: { addNode },
  filters: {
      filterApprovalPerson: (val) => {
          if(val === 2) return '一级部门负责人'
          if(val === 3) return '二级部门负责人'
          if(val === 4) return '三级部门负责人'
          if(val === 5) return '四级部门负责人'
          if(val === 6) return '部门主管'
      }
  }
})
export default class AddNode extends Vue {
    // ------ 变量 ------
    drawerShow = false // 右侧抽屉
    approvalType = ''
    approvalPerson: any[] = []
    editFile: any[] = []
    approvalRange = '' // 审批人范围
    isRequired = '0' // 是否必填
    userIdList: string[] = [] // 审批人、抄送人
    approvalPersonOrLevelType = '' // 审批人类型、审批层级类型
    approvalPersonOrLevelRange = '' // 审批人范围、指定层级
    approvalSettingType = '' // 审批设置
    approvalSettingUserId = '' // 当 approvalSettingType = ‘1‘ 时，必填

    // ------ prop ------
    @Prop() nodeInfo!: any;
    @Prop() conditions!: any;
    @Prop() editFileList!: any; // 可编辑字段列表
    @Prop() conditionFileList!: any

    get userList() {
        return UserModule.userList
    }

    // 计算当前节点显示的审批人、抄送者
    get computedText() {
        let str = ''
        if(this.nodeInfo.types === '2') {
            this.nodeInfo.approvalPersonList.deparments.forEach((item, index) => {
                str = str + item.department.name + (index < this.nodeInfo.approvalPersonList.deparments.length - 1 ? '，' : '')
            });
            this.nodeInfo.approvalPersonList.users.forEach((item, index) => {
                str = str + item.user.realName + (index < this.nodeInfo.approvalPersonList.users.length - 1 ? '，' : '')
            });
        } else if(this.nodeInfo.types === '0')  {
            if(this.nodeInfo.approvalType === '0') {
                // 多人或签
                if(this.nodeInfo.approvalPersonOrLevelType === '0') {
                    str = this.userList.filter(item => this.nodeInfo.userIdList.indexOf(item.id) !== -1).map(item => item.realName).join('，')
                }
                // 单人审批
                if(this.nodeInfo.approvalPersonOrLevelType === '1') {
                    // 公司员工
                    if(this.nodeInfo.approvalPersonOrLevelRange === '0') {
                        str = this.userList.filter(item => item.id === this.nodeInfo.userIdList[0]).map(item => item.realName).join('，')
                    }
                    // 上级合作伙伴负责人
                    if(this.nodeInfo.approvalPersonOrLevelRange === '1') {
                        str = '上级合作伙伴负责人'
                    }
                    if(this.nodeInfo.approvalPersonOrLevelRange === '7') {
                        str = '工单发起人'
                    }
                }
            } else if(this.nodeInfo.approvalType === '1') {
                // 绝对级
                if(this.nodeInfo.approvalPersonOrLevelType === '2') {
                    str = '绝对级：'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '2') str += '一级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '3') str += '二级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '4') str += '三级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '5') str += '四级部门负责人'
                }
                // 相对级
                if(this.nodeInfo.approvalPersonOrLevelType === '3') {
                    str = '相对级：'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '2') str += '上一级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '3') str += '上二级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '4') str += '上三级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '6') str += '部门主管'
                }
            } else if(this.nodeInfo.approvalType === '2') {
                str = '逐级审批：'
                if(this.nodeInfo.approvalPersonOrLevelRange === '2') str += '到一级部门负责人'
                if(this.nodeInfo.approvalPersonOrLevelRange === '3') str += '到二级部门负责人'
                if(this.nodeInfo.approvalPersonOrLevelRange === '4') str += '到三级部门负责人'
                if(this.nodeInfo.approvalPersonOrLevelRange === '5') str += '到四级部门负责人'
                if(this.nodeInfo.approvalPersonOrLevelRange === '6') str += '部门主管'
            }
        } else if(this.nodeInfo.types === '1') {
            if(this.nodeInfo.approvalType === '0') {
                // 公司员工
                if(this.nodeInfo.approvalPersonOrLevelRange === '0') {
                    str = this.userList.filter(item => this.nodeInfo.userIdList.includes(item.id)).map(item => item.realName).join('，')
                }
                // 上级合作伙伴负责人
                if(this.nodeInfo.approvalPersonOrLevelRange === '1') {
                    str = '上级合作伙伴负责人'
                }
            } else if(this.nodeInfo.approvalType === '1') {
                // 绝对级
                if(this.nodeInfo.approvalPersonOrLevelType === '2') {
                    str = '绝对级：'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '2') str += '一级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '3') str += '二级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '4') str += '三级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '5') str += '四级部门负责人'
                }
                // 相对级
                if(this.nodeInfo.approvalPersonOrLevelType === '3') {
                    str = '相对级：'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '2') str += '上一级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '3') str += '上二级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '4') str += '上三级部门负责人'
                    if(this.nodeInfo.approvalPersonOrLevelRange === '6') str += '部门主管'
                }
            }
        }
        return str
    }

    editFileChange(arr) {
        // console.log(arr);
    }

    // 删除节点
    delNode() {
        this.$emit("update:conditions", [...this.nodeInfo.conditionList, ...this.conditions])
        this.$emit("update:nodeInfo", this.nodeInfo.nodeObject);
    }

    // 打开右侧配置弹窗
    clickNode() {
        if(this.nodeInfo.types !== '2') {
            this.approvalType = this.nodeInfo.approvalType
            this.approvalPersonOrLevelType = this.nodeInfo.approvalPersonOrLevelType
            this.approvalPersonOrLevelRange = this.nodeInfo.approvalPersonOrLevelRange
            this.userIdList = this.nodeInfo.userIdList
            this.approvalSettingType = this.nodeInfo.approvalSettingType
            this.approvalSettingUserId = this.nodeInfo.approvalSettingUserId
            this.editFile = this.nodeInfo.editFile.map(item => item.file + item.cnFile)
            this.isRequired = this.nodeInfo.editFile[0] ? this.nodeInfo.editFile[0].isRequired : '0'
            this.drawerShow = true
        }
    }

    // 审批类型改变时
    approvalTypeChange() {
        if(this.approvalType === '0') {
            this.approvalPersonOrLevelType = '0'
        }
        if(this.approvalType === '1') {
            this.approvalPersonOrLevelType = '2'
        }
        if(this.approvalType === '2') {
            this.approvalPersonOrLevelType = ''
        }
        this.userIdList = []
        this.approvalPersonOrLevelRange = ''
    }

    // 审批人类型、审批层级改变时
    approvalPersonOrLevelTypeChange(val: string) {
        if(val === '1') {
            if(this.userIdList.length > 1) {
                this.$message.error('您已选择审批人超过一个，最多选择一个，请删除后重试。')
                this.approvalPersonOrLevelType = '0'
            } else {
                this.userIdList = []
            }
        }
    }

    // 审批人抄送人改变时
    userIdListChange(arr: string[]) {
        // console.log(arr);
    }

    approvalPersonChange() {
        this.nodeInfo.approvUserList = []
        this.approvalPerson.forEach((userId: string) => {
            this.userList.forEach((item: any) => {
                if(item.id == userId) this.nodeInfo.approvUserList.push(item)
            });
        });
    }

    drawerClose(done: any) {
        this.nodeInfo.approvalType = this.approvalType
        this.nodeInfo.approvalPersonOrLevelType = this.approvalPersonOrLevelType
        this.nodeInfo.approvalPersonOrLevelType = this.approvalPersonOrLevelType
        this.nodeInfo.approvalPersonOrLevelRange = this.approvalPersonOrLevelRange
        this.nodeInfo.userIdList = this.userIdList
        this.nodeInfo.approvalSettingType = this.approvalSettingType
        this.nodeInfo.approvalSettingUserId = this.approvalSettingUserId
        this.nodeInfo.editFile = this.editFileList.filter(item => this.editFile.includes(item.enFile + item.zhFile)).map(item => ({ file: item.enFile, cnFile: item.zhFile, isRequired: this.isRequired }))
        if(this.nodeInfo.types === '1' && this.approvalType === '0') {
            delete this.nodeInfo.approvalPersonOrLevelType
        }
        done()
    }

    approvalSettingTypeChange(val: string) {
        if(val === '0') {
            this.approvalSettingUserId = ''
        }
    }

    // ------ 监听 ------
    @Watch('approvalPersonObject', { deep: true })
    WatchApprovalPersonObject(val: any) {
        this.$emit('update:approvalPersonObject', val)
    }
}
